// extracted by mini-css-extract-plugin
export default {"card":"m2-z"};